import { render, staticRenderFns } from "./Keyboard75.vue?vue&type=template&id=35785580&scoped=true&"
import script from "./Keyboard75.vue?vue&type=script&lang=js&"
export * from "./Keyboard75.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard75.vue?vue&type=style&index=0&id=35785580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35785580",
  null
  
)

export default component.exports